import { render, staticRenderFns } from "./KnownMeasuresListPage.vue?vue&type=template&id=1875e7dd&"
import script from "./KnownMeasuresListPage.vue?vue&type=script&lang=js&"
export * from "./KnownMeasuresListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports